{
  "title": "Dashboard 2.0 (Dossier)",
  "chosen": false,
  "prototype": "https://www.figma.com/proto/pHrl5etJmJmwXlG0HQAIr5/Concept-3-%7C-Dashboard-dossier?type=design&node-id=4-2&t=nhZlEV4t441PXDpy-0&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=4%3A2",
  "body": {
    "__html": "<p>Een patiëntendossier waarin de data van de sensoren wordt opgeslagen en een tijdlijn kan vormen voor de patiënt. Hierin wordt week om week de data van de sensor opgeslagen zodat je deze kan vergelijken met vorige weken zodat je kan zien of er verbetering of verslechtering in zit. De data wordt gevisualiseerd doormiddel van grafieken.</p>"
  },
  "functionalities": [
    "Opslag van sensordata in een digitaal patiëntendossier.",
    "Visualisatie van data in grafieken over een langere periode.",
    "Vergelijking van data van verschillende periodes.",
    "Trendanalyse van data voor het monitoren van voortgang."
  ],
  "prosandcons": {
    "pros": [
      "Je kan voorspellingen doen over verschillende aspecten van een patient met genoeg data.",
      "Lange termijn opslag van sensordata voor referentie creert een referentie bank voor iedere patient.",
      "De mogelijkheid om trends en patronen in de data te analyseren.",
      "je kan beoordelingen doen van de voortgang van de patiënt naarmate de nieuwere metingen.",
      "Ondersteuning bij het maken van gepersonaliseerde behandelplannen."
    ],
    "cons": [
      "Complexer dan een dashboard met actuele data.",
      "Vereist langere datatermijn voor bruikbare analyses.",
      "Mogelijk minder geschikt voor snelle observatie van actuele waarden.",
      "Metingen in de lange termijn kunnen veel opslag nodig hebben."
    ]
  },
  "images": [
    "img/Dashboard2.png"
  ]
}
